import { createFileRoute } from '@tanstack/react-router'
import { BenchmarkPage } from '../../components/benchmark/BenchmarkPage'

/**
 * The intra-portfolio benchmark (spec 2026-09-13-01). Every choice on the
 * screen — view, metric, trade, building, window, size stratum, currency —
 * lives in the URL, so a benchmark can be bookmarked and sent.
 */
export const Route = createFileRoute('/$org/benchmark')({
  component: BenchmarkPage,
  validateSearch: (search: Record<string, unknown>) => ({
    view: search.view === 'asset' ? ('asset' as const) : undefined,
    metric: search.metric ? String(search.metric) : undefined,
    // The breakdown key (a trade root) of a breakdown KPI.
    key: search.key ? String(search.key) : undefined,
    asset: search.asset ? String(search.asset) : undefined,
    // Last closed month of the window, YYYY-MM.
    window_end: search.window_end ? String(search.window_end) : undefined,
    strata: search.strata ? String(search.strata) : undefined,
    currency: search.currency ? String(search.currency) : undefined,
  }),
})
